import React from 'react'
import Therapies from './TherapyOffered/Therapies'

export default function TherapyOffered() {
  return (
    <div>
        <Therapies />
   
    </div>

  )
}
